import './landing.css';
import React, { useState, useContext } from 'react';
import Context from '../../context';
import { login } from '../../api';
import { cn } from './../../utils'

import Cards from '../../components/cards';
import SignUp from '../../components/signup';
import LogoGpk from '../../components/logo-gpk';
import RedeemCode from '../../components/redeem-code';

import logoTops from './../../img/topps.svg';

const LandingPage = () => {
  const [waxApi, setWaxApi] = useState(null);

  const {wax, setWax} = useContext(Context);

  autoLogin();

  async function autoLogin() { 
    var isAutoLoginAvailable = await wax.isAutoLoginAvailable(); 
    if (isAutoLoginAvailable) { 
      handlerLogin(); 
    } 
  }

  const handlerLogin = () => {
    login(wax)
    .then(result => {
      if(result) {
        setWax(result)
        setWaxApi(result.api)
      }
    })
  }

  return (
    <div className={cn('landing', waxApi && 'auth')}>
      <div id="landingpage">
        <h1>
          <img className="topps" src={logoTops} alt="Topps" />
          <br />
          On the <b>WAX BLOCKCHAIN</b> since <b>2020</b>
        </h1>
        {!waxApi ?  <LogoGpk />  : null}
        <div className="actions">
          {!waxApi  ? <SignUp handlerLogin={handlerLogin} /> : <RedeemCode />}
        </div>
        <Cards />
      </div>
    </div>
  )
}

export default LandingPage;